/*
 * Project: LegalPlace assistant
 * File: src\middlewares\middlewares.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


// in this phase we import other middleware (csutom)
import thunk from 'redux-thunk';
import { trialMiddleware } from './customTest';
import { countThings } from './count_things';


// declare everything
// adding thunk middleware

const middlewares = [
  // trialMiddleware,
  countThings,
  thunk,
];


export default middlewares;



// WEBPACK FOOTER //
// ./src/middlewares/middlewares.js